import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "VolumenOff",
  "use": "VolumenOff-usage",
  "viewBox": "0 0 44 33",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 44 33\" id=\"VolumenOff\"><path d=\"M6.667 11H0v11h6.667L20 33V0L6.667 11zm32.343 6.084l4.572-4.572-3.304-3.304-4.573 4.572-4.572-4.572-3.304 3.304 4.572 4.572-4.572 4.573 3.304 3.304 4.572-4.572 4.573 4.572 3.304-3.304-4.572-4.573z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol